import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        //console.log(payload);

        const dateArray = payload.issueDate.split('/');

        let result = await apiClient(config).apiMethod({
            method: 'Feedback',
            args: {
                ConnectionSpeed: payload.connectionSpeed,
                EmailAddress: payload.email,
                FirstName: payload.firstname,
                FlashVersion: 'Unused',
                IssueCategory: 'Feedback',
                IssueDay: dateArray[1],
                IssueDescription: payload.comments,
                IssueMonth: dateArray[0],
                IssueType: '',
                IssueYear: dateArray[2],
                IssueZone: payload.issue_zone,
                LastName: payload.lastname,
                Phone: payload.phone,
                Promotion: payload.promotion,
                ZipCode: payload.zipcode,
            },
        });

        if (!result.success) {
            if (result.errorText) {
                return {
                    ...result,
                    isError: true,
                    error: result.errorText,
                };
            } else if (result.code) {
                return {
                    ...result,
                    success: false,
                    isError: true,
                    error: result.data,
                };
            }
        } else {
            return {
                ...result,
                isError: false,
                error: {},
            };
        }
    };
};
